import { useState, useEffect } from 'react';
import classNames from 'classnames';
import { PorangeButton } from "@/components/atoms/PorangeButton";

export const Statement = ({ onAnswer }) => {
    const [showFirstLine, setShowFirstLine] = useState(false);
    const [showSecondLine, setShowSecondLine] = useState(false);
    const [showButton, setShowButton] = useState(false);
    const [isExiting, setIsExiting] = useState(false);

    useEffect(() => {
        setTimeout(() => setShowFirstLine(true), 100);
        setTimeout(() => setShowSecondLine(true), 400);
        setTimeout(() => setShowButton(true), 1000);
    }, []);

    const handleContinue = () => {
        setShowButton(false);
        setIsExiting(true);
        setTimeout(() => onAnswer('continue'), 800);
    };

    return (
        <div className={classNames(
            "relative h-full flex flex-col items-center justify-start px-6",
            isExiting ? "opacity-0" : "opacity-100",
            "transition-opacity duration-500"
        )}>
            <div className="mt-4 mb-8">
                <span className="text-7xl">👩‍⚕️</span>
            </div>

            <div className="text-center space-y-4 max-w-[600px]">
                <div className="overflow-hidden">
                    <h2 
                        className={classNames(
                            "text-[32px] md:text-[40px] leading-tight font-bold transition-opacity duration-300 text-black",
                            showFirstLine ? "opacity-100" : "opacity-0"
                        )}
                    >
                       Atly works with {' '}
                        <span className="animate-shimmer bg-[length:200%_100%] bg-clip-text text-transparent bg-gradient-to-r from-pink-500 via-orange-500 to-pink-500">
                            doctors and dietitians
                        </span>{' '} to determine safety
                    </h2>
                </div>
                
                <div className="overflow-hidden">
                    <h3 
                        className={classNames(
                            "text-xl md:text-2xl text-gray-600 transition-opacity duration-300",
                            showSecondLine ? "opacity-100" : "opacity-0"
                        )}
                    >
                        Kitchen protocols, menu items, staff training are reviewed to determine safety standards
                    </h3>
                </div>
            </div>

            <div 
                className={classNames(
                    "fixed bottom-0 left-0 right-0 p-5 transition-all duration-500 bg-gradient-to-t from-white via-white to-transparent pb-6 pt-10",
                    showButton ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8 pointer-events-none"
                )}
            >
                <PorangeButton
                    full={true}
                    className="h-[56px] rounded-[16px] text-lg shadow-md"
                    onClick={handleContinue}
                >
                    Continue
                </PorangeButton>
            </div>

            <style jsx global>{`
                @keyframes shimmer {
                    0% { background-position: 200% 0; }
                    100% { background-position: -200% 0; }
                }

                .animate-shimmer {
                    animation: shimmer 3s linear infinite;
                }
            `}</style>
        </div>
    );
};

export default Statement; 